import { render } from "./NotificationApiModelHistory.vue?vue&type=template&id=226ce54b"
import script from "./NotificationApiModelHistory.vue?vue&type=script&lang=js"
export * from "./NotificationApiModelHistory.vue?vue&type=script&lang=js"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__